import { PartnerCustomFilter, PartnerFilterOption } from "@rubi/api-generated";

export interface CustomFilterDraft {
  id: string;
  label: string;
  fieldKey: string;
  multiple: boolean;
  optionsText: string;
}

export const emptyCustomFilterDraft: CustomFilterDraft = {
  id: "",
  label: "",
  fieldKey: "",
  multiple: false,
  optionsText: "",
};

export const parseFilterOptions = (
  text: string,
): PartnerFilterOption[] | null => {
  const options = text
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean)
    .map((line) => {
      const comma = line.indexOf(",");
      const value = (comma === -1 ? line : line.slice(0, comma)).trim();
      const label = comma === -1 ? "" : line.slice(comma + 1).trim();
      return { value, label: label || value };
    });
  return options.length > 0 ? options : null;
};

const formatFilterOptions = (options: PartnerFilterOption[]) =>
  options
    .map((o) => (o.label === o.value ? o.value : `${o.value},${o.label}`))
    .join("\n");

export const toCustomFilterDraft = (
  filter: PartnerCustomFilter,
): CustomFilterDraft => ({
  id: filter.id,
  label: filter.label,
  fieldKey: filter.field_key,
  multiple: filter.multiple ?? false,
  optionsText: formatFilterOptions(filter.options ?? []),
});

export const fromCustomFilterDraft = (
  draft: CustomFilterDraft,
): PartnerCustomFilter => {
  const options = parseFilterOptions(draft.optionsText);
  return {
    id: draft.id.trim(),
    label: draft.label.trim(),
    field_key: draft.fieldKey.trim(),
    multiple: options ? draft.multiple : false,
    options,
  };
};
